function generateSrcset(imageUrl) {
  // Remove any existing width param
  const cleanUrl = imageUrl.replace(/([&?])width=\\d+/, '');
  const widths = [352, 832, 1200, 1920];
  return widths.map(w => `${cleanUrl}${cleanUrl.includes('?') ? '&' : '?'}width=${w} ${w}w`).join(', ');
}